<cmps-dialog
    class="cmps-cdk-p-0 cmps-cdk-pos-relative cmps-cdk-overflow-hidden cmps-cdk-border-width-0p"
    [class.cmps-cdk-h-100p]="!_service.state?.minimized"
>
    <cmps-dialog-body
        class="cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-z-index-1"
        [class.cmps-cdk-h-100p]="_service.state?.minimized !== true"
    >
        <div
            class="cmps-cdk-px-1 cmps-cdk-py-0dot5 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-bg-color-unknown-108"
        >
            <div class="cmps-cdk-d-flex cmps-cdk-flex-column">
                <div
                    class="cmps-cdk-font-bold cmps-cdk-font-size-16p cmps-cdk-color-white"
                >
                    Your session brief
                </div>
                <div
                    class="cmps-cdk-font-size-10p cmps-cdk-color-unknown-121 cmps-cdk-font-italic"
                >
                    {{ _service.state?.result?.guideConfigName }}
                </div>
            </div>
            <div
                class="cmps-cdk-ml-1 cmps-cdk-font-size-20p cmps-cdk-font-bold"
                *ngIf="_service.state?.phase?.live === true"
            >
                <cmps-icon
                    class="d-inline-block cmps-cdk-ml-0dot5"
                    [class.cmps-cdk-fill-grey-400]="
                        _service.state.transcriptStatus !== 'green'
                    "
                    [class.cmps-cdk-fill-green-100]="
                        _service.state.transcriptStatus === 'green'
                    "
                    svgIcon="circle"
                ></cmps-icon>
            </div>
            <div class="cmps-cdk-flex-grow-1"></div>
            <div>
                <cmps-ca-analysis-dialog-toolbar
                    [evalRef]="evalRef"
                    [background]="'dark'"
                    [withProTips]="true"
                ></cmps-ca-analysis-dialog-toolbar>
            </div>
            <div>
                <button
                    cmpsIconButton
                    [cmpsTooltipTrigger]="
                        _service.state?.minimized
                            ? (_i18n._11193_MAXIMIZE | translate)
                            : (_i18n._11192_MINIMIZE | translate)
                    "
                    (click)="_onMinMaxClick()"
                >
                    <cmps-icon
                        class="cmps-cdk-bg-color-transparent cmps-cdk-fill-white hover:cmps-cdk-fill-unknown-121"
                        [svgIcon]="_service.state?.minimized ? 'plus' : 'minus'"
                    ></cmps-icon>
                </button>
                <button
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._763_CLOSE | translate"
                    (click)="_dialogRef._close()"
                >
                    <cmps-icon
                        class="cmps-cdk-bg-color-transparent cmps-cdk-fill-white hover:cmps-cdk-fill-unknown-121"
                        svgIcon="close"
                    ></cmps-icon>
                </button>
            </div>
        </div>
        <div
            class="cmps-cdk-flex-column cmps-cdk-mb-0dot5 cmps-cdk-overflow-hidden"
            [class.cmps-cdk-d-flex]="_service.state?.minimized !== true"
            [class.cmps-cdk-d-none]="_service.state?.minimized === true"
        >
            <div class="cmps-cdk-overflow-y-auto">
                <cmps-ca-evaluation
                    [caResult]="_service.state?.result"
                    [showReasoning]="false"
                    [asAutomatedCheckList]="false"
                    [asManualCheckList]="true"
                    [phase]="_service.state?.phase"
                    #evalRef
                ></cmps-ca-evaluation>
            </div>
        </div>
        <div class="cmps-cdk-flex-grow-1"></div>
        <div
            class="cmps-cdk-border-t-width-1px cmps-cdk-border-t-solid cmps-cdk-border-t-color-unknown-107"
        ></div>
        <div
            class="cmps-cdk-px-1 cmps-cdk-py-0dot5 cmps-cdk-d-flex cmps-cdk-align-items-center"
            *ngIf="_service.state?.phase?.live !== true"
        >
            <div class="cmps-cdk-w-100pct">
                <cmps-ca-analysis-dialog-call-bar></cmps-ca-analysis-dialog-call-bar>
            </div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>

<!--<ng-template #hudBtnTpl>
    <div>
        <button
            class="cmps-icon-button&#45;&#45;no-bg"
            cmpsIconButton
            [cmpsTooltipTrigger]="
                _i18n._11191_INTELLIGENT_COACH_ASSIST_GPS | translate
            "
            placement="bottom-center"
            (click)="_service.isOpen ? _service.close() : _service.open(_data)"
        >
            <cmps-icon svgIcon="post-outline"></cmps-icon>
        </button>
    </div>
</ng-template>-->
